<div class="form-field" [formGroupName]="controlKey">
  <tui-input
    class="input"
    [tuiTextfieldLabelOutside]="true"
    [pseudoInvalid]="validationStatus === 'invalid'"
    [tuiTextfieldCustomContent]="statusTmp"
    [tuiHint]="statusHint"
    [tuiHintDirection]="'right-bottom'"
    formControlName="address"
  >
    {{ 'components.geocoder.fields.enterAddress' | translate }}
  </tui-input>

  <button
    tuiIconButton
    type="button"
    [iconStart]="'@tui.x'"
    [appearance]="'accent'"
    [size]="'s'"
    (click)="deleteField.emit()"
  ></button>
</div>

<ng-template #statusTmp>
  <app-icon
    *ngIf="statusIcon"
    [color]="validationStatus === 'invalid' ? 'var(--tui-background-accent-2)' : 'var(--unions-color-green)'"
    [src]="statusIcon"
  ></app-icon>
</ng-template>
